"use client";
import { create } from "zustand";

type Notice = {
  selector: string;
  html: string;
  settings: object;
  rules: object;
  theme: object;
  id: string;
};

interface XNoticeStore {
  categories: string[];
  cartProducts: string[];
  cartCategories: string[];
  product: string;
  manufacturer: string;
  notices: Notice[];
  addNotice: (notice: Notice) => void;
  removeNotice: (selector: string) => void;
  clearNotices: () => void;
  setManufacturerID: (id: string) => void;
  setCategoryIDs: (ids: string[]) => void;
  setCartCategoryIDs: (ids: string[]) => void;
  setProductID: (id: string) => void;
  setCartProductIDs: (ids: string[]) => void;
}

export const useXNoticeStore = create<XNoticeStore>((set) => ({
  notices: [],
  categories: [],
  cartProducts: [],
  cartCategories: [],
  product: "",
  manufacturer: "",
  setCategoryIDs: (ids: string[]) => set({ categories: ids }),
  setProductID: (id: string) => set({ product: id }),
  setCartProductIDs: (ids: string[]) => set({ cartProducts: ids }),
  setCartCategoryIDs: (ids: string[]) => set({ cartCategories: ids }),
  setManufacturerID: (id: string) => set({ manufacturer: id }),
  addNotice: (newNotice) =>
    set((state) => ({
      notices: [...state.notices, newNotice],
    })),
  removeNotice: (selector) =>
    set((state) => ({
      notices: state.notices.filter((notice) => notice.selector !== selector),
    })),
  clearNotices: () => set({ notices: [] }),
}));
